var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"notice_container pos_fix flex_center",class:_vm.type + '_notice',style:({'top': _vm.top + 'px', 'opacity': _vm.opacity})},[_c('div',{staticClass:"notice_info"},[_c('span',[_vm._v(_vm._s(_vm.content))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fe08316","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice/index.vue
// module id = null
// module chunks = 